<template>
  <div v-if="pageComponent" :id="pageComponent.uuid" :ref="pageComponent.uuid" :data-type="pageComponent.properties.element_type" :class="customClasses" :style="mapCssProperties">
    <div>
      <form :id="pageComponent.uuid + '-form'" class="form">
        <kiosk-elements v-for="element in pageComponent.parent_elements" :key="element.uuid"
                        :element="element"
                        :sessionUuid="sessionUuid" />
        <kiosk-form-child-components v-for="component in pageComponent.children" :key="component.uuid"
                                     :component="component"
                                     :parentComponent="pageComponent"
                                     :sessionUuid="sessionUuid"
                                     :formData="form" />
      </form>
    </div>
  </div>
  <loading-overlay v-else />
</template>

<script>
import _ from 'lodash';
import LoadingOverlay from '../services/loading-overlay.vue';
import HelperMethods from '../mixins/helper_methods';
import ComponentEventHelper from '../mixins/component_event_helper';
import KioskElements from '../elements/kiosk-elements.vue';
import OrderingHelper from '../mixins/ordering_helper';

export default {
  name: 'KioskFormRoot',
  mixins: [HelperMethods, OrderingHelper, ComponentEventHelper],
  components: {
    KioskFormChildComponents: () => import('./kiosk-form-child-components.vue'),
    LoadingOverlay,
    KioskElements,
  },
  props: {
    pageComponent: Object,
    parentComponent: Object,
    kioskProperties: Object,
    sessionUuid: String,
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(newVal) {
        // Updating page component with the form Data (accessible in user_events)
        this.pageComponent.formData = newVal;
      },
    },
    stillRequiredFields: {
      handler(newVal, oldVal) {
        // Check if the form needs to be reset
        if (this.resetForm === true) {
          // Reset form data
          this.resetFormData();
        }

        if (oldVal && oldVal.length > 0) {
          // Remove the required class on last set of required items
          _.forEach(oldVal, (v) => {
            const formElement = document.getElementById(v.id);
            if (formElement) {
              // hide error message for element
              const errorMsg = formElement.nextSibling;
              if (errorMsg) {
                errorMsg.classList.remove('active');
              }
            }
          });
        }

        if (newVal && newVal.length > 0) {
          // add required to required fields that aren't filled out
          _.forEach(newVal, (val) => {
            const formElement = document.getElementById(val.id);

            if (formElement) {
              // hide error message for element
              const errorMsg = formElement.nextSibling;
              if (errorMsg) {
                errorMsg.classList.add('active');
              }
            }
          });
        }
      },
    },
  },
  data() {
    return {
      properties: this.pageComponent.properties,
      formInput: null,
      form: {
        selects: [],
        inputs: [],
        textareas: [],
        checkboxes: [],
        requiredFields: [],
      },
      stillRequiredFields: false,
      originalFormData: null,
      resetForm: false,
    };
  },
  mounted() {
    // set required fields here and check if they have been populated in the event
    this.pageComponent.required_fields = [];
  },
  methods: {
    resetFormData() {
      // Get form
      const form = document.getElementById(`${this.pageComponent.uuid}-form`);

      if (form) {
        // Reset all form inputs values
        _.forEach(form.elements, (val) => {
          const formEle = val;

          if (formEle.type === 'checkbox') {
            formEle.checked = false;
          }

          if (formEle.type === 'textarea') {
            formEle.innerHTML = '';
          }
        });
        form.reset();
      }
      _.forEach(this.pageComponent.formData, (v) => {
        _.forEach(v, (x) => {
          const input = x;
          if (input.value) {
            if (typeof input.value === 'boolean') {
              input.value = false;
            } else {
              input.value = null;
            }
          }
        });
      });
      this.resetForm = false;
    },
    resetCallback() {
      this.form = {
        selects: [],
        inputs: [],
        textareas: [],
        checkboxes: [],
        requiredFields: [],
      };
      this.formInput = null;
      this.stillRequiredFields = false;
      this.originalFormData = null;
      this.resetForm = false;
      this.pageComponent.required_fields = [];
      this.resetFormData();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
